"use client"

import { useRef, useEffect } from "react"

interface HealthBarProps {
  current: number
  max: number
  scale: number
  variant?: "game" | "shop"
}

export const HealthBar = ({ current, max, scale, variant = "game" }: HealthBarProps) => {
  const percent = max > 0 ? (current / max) * 100 : 0
  const barRef = useRef<HTMLDivElement>(null)

  // Force DOM update when health changes (fixes potential React batching issues)
  // Only needed for game variant where immediate updates are critical
  useEffect(() => {
    if (variant === "game" && barRef.current) {
      barRef.current.style.width = `${percent}%`
    }
  }, [percent, variant])

  const width = 82 * scale
  const height = 5 * scale
  const left = 20 * scale
  const top = 119 * scale

  const barId = variant === "game" ? "hero-health-bar" : "shop-health-bar"

  // Game variant uses ref-based updates for performance
  // Shop variant uses standard React rendering with Tailwind transitions
  const barStyle = variant === "game"
    ? { width: `${percent}%`, transition: "width 0.1s ease-out" }
    : { width: `${percent}%` }

  const barClassName = variant === "game"
    ? "h-full bg-game-health"
    : "h-full bg-game-health transition-all duration-200"

  return (
    <div
      id={barId}
      className="absolute overflow-hidden"
      style={{
        left,
        top,
        width,
        height,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        borderRadius: 2 * scale,
      }}
    >
      <div
        ref={variant === "game" ? barRef : null}
        className={barClassName}
        style={barStyle}
      />
    </div>
  )
}
